import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import MainAvatar from './MainAvatar'
import SnsButton from '../shared/SnsButton'
import PageSEO from '../shared/PageSEO'
import { SOCIAL_LINKS } from '../../constants/social'

function Main() {
  const { t } = useTranslation()

  return (
    <>
      <PageSEO 
        title="Hyunjin Jae | Home"
        description="Welcome to my personal website. I'm a software developer specializing in web development."
        keywords="home, personal website, software developer, web development"
        tags={['home', 'personal', 'developer']}
      />
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            maxWidth: '1000px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 4
          }}
        >
          {/* 아바타 + 이름/타이틀 */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'center',
              gap: { xs: 2, md: 4 }
            }}
          >
            <Box
              sx={{
                width: { xs: 160, md: 200 },
                height: { xs: 160, md: 200 },
                borderRadius: 2,
                boxShadow: '0 6px 20px rgba(0, 0, 0, 0.12)',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              <MainAvatar />
            </Box>

            <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2E3B55' }}>
                {t('shared:hyunjin')}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 500,
                  color: '#2E3B55',
                  whiteSpace: 'pre-line',
                  letterSpacing: '0.2px',
                  fontSize: '1rem'
                }}
              >
                {t('main:tagline')}
              </Typography>

              {/* SNS 버튼 영역 */}
              <Box
                display="flex"
                flexWrap="wrap"
                gap={1.5}
                sx={{
                  mt: 1,
                  justifyContent: { xs: 'center', md: 'flex-start' }
                }}
              >
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', justifyContent: 'center' }}>
                  <SnsButton link={SOCIAL_LINKS.email} color="warning" icon="fa-solid fa-envelope" name="Email" />
                  <SnsButton link={SOCIAL_LINKS.linkedIn} color="success" icon="fa-brands fa-linkedin" name="LinkedIn" />
                  <SnsButton link={SOCIAL_LINKS.github} color="secondary" icon="fa-brands fa-github" name="Github" />
                </Box>
              </Box>
            </Box>
          </Box>

          {/* 소개 텍스트 */}
          <Box sx={{ width: '100%', textAlign: 'justify' }}>
            <Typography
              variant="body1"
              sx={{ fontSize: '15px', lineHeight: 1.7, mb: 2 }}
            >
              {t('main:intro.paragraph1')}
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: '15px', lineHeight: 1.7, mb: 2 }}
            >
              {t('main:intro.paragraph2')}
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: '15px', lineHeight: 1.7, mb: 2 }}
            >
              {t('main:intro.paragraph3')}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Main
